import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

// A titled section with an optional one-line description and a "See all" link.
// Gives every screen the same calm, editorial rhythm.
export function HubSection({
  title,
  description,
  seeAllTo,
  action,
  children,
  className,
}: {
  title: string;
  description?: string;
  seeAllTo?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("space-y-3", className)}>
      <div className="flex items-end justify-between gap-3">
        <div className="min-w-0">
          <h2 className="font-heading text-lg font-medium text-foreground">{title}</h2>
          {description && <p className="font-body text-sm text-muted-foreground">{description}</p>}
        </div>
        {seeAllTo ? (
          <Link to={seeAllTo} className="font-body text-sm text-primary hover:underline shrink-0">
            See all
          </Link>
        ) : (
          action
        )}
      </div>
      {children}
    </section>
  );
}
